import makeVueModal from '@/views/modal/make_vue_modal';
import track from '@/helpers/track';

let modal = null;

$(document).on('turbolinks:before-cache', () => {
  if (modal) {
    modal.destroy();
    modal = null;
  }
});

pageLoad('pages_root', async () => {
  if (!document.body.className.includes('v4')) { return; }

  $('article.slide_11 button.lead').one('click', async ({ currentTarget }) => {
    const { default: vueComponent } = await import('@/vue/modals/call_lead');
    modal ||= makeVueModal({
      trigger: currentTarget,
      vue: { Component: vueComponent },
      isCloseOnSubmit: true,
      onShow: () => {
        const { trackEventLocation } = $(currentTarget).data();
        track({ event: 'callback_form_opened', data: trackEventLocation });
      }
    });
    modal.show();
  });
});
